import { render, staticRenderFns } from "./PlanesInformacion.vue?vue&type=template&id=49c3bbbf&scoped=true"
import script from "./PlanesInformacion.vue?vue&type=script&lang=js"
export * from "./PlanesInformacion.vue?vue&type=script&lang=js"
import style0 from "./PlanesInformacion.vue?vue&type=style&index=0&id=49c3bbbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c3bbbf",
  null
  
)

export default component.exports